<script>
    import { http } from '../../http';
    import moment from 'moment';
    import DatePicker from '../global/form/DatePicker.vue';
    import range from 'lodash/range';
    import sortBy from 'lodash/sortBy';
    import Switchery from './form/Switchery.vue';
    import TimePicker from '../mixins/TimePicker.vue';

    export default {
        data() {
            return {
                available_times : this.get_available_times("00:00", "23:55", 5),
                calendar: this.initial_calendar,
                current_pauses: {},
                current_times: {},
                date_range: '',
                loading: true,
                new_pause: {},
                openingTimes: {},
                pause_loading: false,
                year: moment().format('YYYY'),
                week: '0',
                is_even: false,
                reset_hour_option: 'this-week',
                submitting_reset_hours: false,
                available_end_times: Array(7).fill(this.get_available_times("00:00", "23:55", 5)),
                weekdays:  {
                    1: 'monday',
                    2: 'tuesday',
                    3: 'wednesday',
                    4: 'thursday',
                    5: 'friday',
                    6: 'saturday',
                    7: 'sunday',
                },
            }
        },

        props: {
            initial_calendar: {
                default: () => {return {}},
            },

            show_submit_button: {
                default: true,
            },

            submission_handler: {
                type: Function,
            },

            user: {
                required: true
            }
        },

        mounted() {

            this.$event_bus.$on('loadOpeningTimes', (calendar, year, week, even) => {
                this.calendar = typeof calendar !== 'undefined' ? calendar : this.calendars[0];
                this.year = typeof year !== 'undefined' ? year : this.year;
                this.week = typeof week !== 'undefined' ? week : this.week;
                this.is_even = typeof even !== 'undefined' ? even : this.is_even;

                this.loadOpeningTimes();

                this.bindElements();
            });

            this.$event_bus.$on('calendarsLoaded', () => {
                this.calendar = this.calendars[0];
            });

            this.$event_bus.$on('submitOpeningTimes', () => {
                this.submitOpeningTimes();
            });

            this.$on('week', (week) => {
                this.week = week;
            });

            this.$on('year', (year) => {
                this.year = year;
            });

            this.$on('is_even', (even) => {
                this.is_even = even;
            });

            if (this.calendar === false) {
                this.loadDefaultOpeningTimes();
            }
        },

        methods: {
            changeWeek(weekNumber) {
                this.week = weekNumber;
            },

            changeYear(yearNumber) {
                this.year = yearNumber;
            },

            clearWeeklyData() {
                // If we change the base times, we should clear the cache for all other weeks, to make sure they don't contain the removed pause.
                this.openingTimes[this.calendar.id][+ this.is_even][this.year] = {
                    '0': this.openingTimes[this.calendar.id][+ this.is_even][this.year]['0'],
                }
            },

            createPause() {
                this.current_pauses = $.extend({}, this.getWeeksOpeningTimes().pauses);

                this.new_pause.year = this.year;
                this.new_pause.week = this.week;
                this.new_pause.even = this.is_even;

                var start_hour = parseInt(this.new_pause.starttime.split(':')[0]);
                var start_minute = parseInt(this.new_pause.starttime.split(':')[1]);
                var end_hour = parseInt(this.new_pause.endtime.split(':')[0]);
                var end_minute = parseInt(this.new_pause.endtime.split(':')[1]);

                if ( (start_hour > end_hour) || (start_hour === end_hour && start_minute >= end_minute) ) {
                    swal({
                        title:  trans('global.oops'),
                        text: trans('online_booking.pause_start_before_end'),
                        showCancelButton: false,
                        html: false,
                        showLoaderOnConfirm: true,
                        closeOnConfirm: false,
                    });

                    return;
                }

                var url = '/app/calendar/';
                if (this.calendar) {
                    url += this.calendar.id + '/';
                }
                url += 'pause';

                http.post(url, this.new_pause)
                    .then(({ data }) => {
                        if (this.week == 0 && this.calendar) {
                            this.clearWeeklyData();
                        }

                        if (this.calendar) {
                            this.getWeeksOpeningTimes().pauses[this.new_pause.weekday].push(data);
                        }else {
                            this.current_pauses[this.new_pause.weekday].push(data)
                        }

                        if (!this.current_pauses[this.new_pause.weekday]) {
                            this.current_pauses[this.new_pause.weekday] = [];
                        }

                        $('#pause-modal').modal('hide');
                    }).catch(() => {});
            },

            fetchOpeningTimes (year, week, even) {
                const data = {
                    year: year,
                    week: week,
                    even: even,
                }

                this.loading = true;

                return http.get('/app/calendar/' + this.calendar.id + '/opening-times', {params: data})
                    .then(({ data }) => {
                        this.loading = false;
                        this.openingTimes[this.calendar.id][+ even][year][week] = data;
                        return data;
                    }).catch(() => {});
            },

            getTimeFromDateString(string) {
                return moment(string).format('HH:mm')
            },

            loadDefaultOpeningTimes() {
                var times = {};
                var pauses = {};

                for (var i = 1; i <= 5; i++) {
                    times[i] = {
                        closed: 0,
                        closing_time: "17:00",
                        opening_time: "09:00",
                        weekday: i,
                    }

                    pauses[i] = [];
                }

                for (var i = 6; i <= 7; i++) {
                    times[i] = {
                        closed: 1,
                        closing_time: "17:00",
                        opening_time: "09:00",
                        weekday: i,
                    }

                    pauses[i] = [];
                }

                this.current_times = $.extend({}, this.setOpenValues(times));
                this.current_pauses = pauses;

                this.$nextTick(() => {
                    this.loading = false;
                });
            },

            loadOpeningTimes() {
                if (! this.calendar) {
                    return;
                }

                if (! this.calendar.odd_even_opening_times) {
                    this.is_even = false;
                }

                if (!this.openingTimes[this.calendar.id]) {
                    this.openingTimes[this.calendar.id] = {};
                }

                if (!this.openingTimes[this.calendar.id][+ this.is_even]) {
                    this.openingTimes[this.calendar.id][+ this.is_even] = {};
                }

                if (!this.openingTimes[this.calendar.id][+ this.is_even][this.year]) {
                    this.openingTimes[this.calendar.id][+ this.is_even][this.year] = {};
                }

                if (this.getWeeksOpeningTimes()) {
                    this.setCurrentTimes();
                } else {
                    this.fetchOpeningTimes(this.year, this.week, this.is_even)
                        .then(() => {
                            this.setCurrentTimes();
                            this.bindElements();
                        }).catch(() => {});
                }
            },

            getWeeksOpeningTimes() {
                return this.openingTimes[this.calendar.id][+ this.is_even][this.year][this.week];
            },

            bindElements() {
                this.$nextTick(() => {
                    var el = document.getElementById('pause-modal');
                    var elOpeningHours = document.getElementById('opening-hours-reset-modal');

                    if (el) {
                        // We move the pause modal markup to another part of the page, to allow this component to be embedded in another modal.
                        document.getElementById('app').appendChild(el);
                    }

                    if (elOpeningHours) {
                        // We move the reset opening hours modal markup to another part of the page, to allow this component to be embedded in another modal.
                        document.getElementById('app').appendChild(elOpeningHours);
                    }
                });
            },

            orderedWeekdayPauses(weekday) {
                return sortBy(this.current_pauses[weekday], (pauses) => { return pauses.starttime; });
            },

            removePause(pause) {
                // Pauses for specific dates doesn't have a weekday set, but having it makes everything so much nicer to work with.
                if (!pause.weekday) {
                    // We use 7 as Sunday, instead of moment's 0.
                    pause.weekday = moment(pause.date).day() ? moment(pause.date).day() : 7;
                }

                this.current_pauses[pause.weekday] = this.current_pauses[pause.weekday].filter((p) => {
                    return p.id !== pause.id;
                });

                this.getWeeksOpeningTimes().pauses[pause.weekday] = this.getWeeksOpeningTimes().pauses[pause.weekday].filter((p) => {
                    return p.id !== pause.id;
                });

                if (this.week === 0) {
                    this.clearWeeklyData();
                }

                var url = '/app/calendar/';
                if (this.calendar) {
                    url += this.calendar.id + '/';
                }
                url += 'pause/' + pause.id;

                http.delete(url, {params:{
                        week: this.week ,
                        year: this.year
                }});
            },

            setClosedValues(times) {
                for (var i = 1; i <= 7; i++) {
                    times[i].closed = !times[i].open;
                }

                return times;
            },

            setCurrentTimes() {
                var times = $.extend({}, this.getWeeksOpeningTimes().times);
                this.current_times = this.setOpenValues($.extend(times, this.getWeeksOpeningTimes().special_cases));
                this.current_pauses = $.extend({}, this.getWeeksOpeningTimes().pauses);
            },

            setOpenValues(times) {
                for (var i = 1; i <= 7; i++) {
                    times[i].open = !times[i].closed;
                }
                this.resetAvailableEndTimes();
                return times;
            },

            getFromAvailableTimes(time) {
                return this.available_times.find(t => t === time);
            },

            showPauseForm(weekday) {
                var pause = {
                    starttime: this.getFromAvailableTimes(this.current_times[weekday].opening_time),
                    endtime: this.getFromAvailableTimes(this.current_times[weekday].closing_time),
                    weekday: weekday,
                }

                if (this.calendar && !this.getWeeksOpeningTimes().pauses[weekday]) {
                    this.getWeeksOpeningTimes().pauses[weekday] = [];
                }

                this.new_pause = pause;
                $('#pause-modal').modal('show');
            },

            showResetHoursForm() {
                this.reset_hour_option = this.no_week_selected ? 'all-weeks' : 'this-week';

                $('#opening-hours-reset-modal').modal('show');
            },

            resetHours() {
                if (! this.calendar || this.submitting_reset_hours) return;

                this.submitting_reset_hours = true;

                const url = '/app/calendar/' + this.calendar.id + '/reset-opening-times';

                return http.post(url, {option: this.reset_hour_option, year: this.year, week: this.week, even: this.is_even})
                    .then(({ data }) => {

                        this.clearWeeklyData();

                        $('#opening-hours-reset-modal').modal('hide');

                        this.reloadState();

                        this.$data.reset_hour_option = this.$options.data.call(this).reset_hour_option;

                        toastr.success(data.success);

                    })
                        .catch(() => {})
                        .finally(() => this.submitting_reset_hours = false);
            },

            reloadState() {
                const resetOption = this.reset_hour_option;
                this.fetchOpeningTimes(this.year, this.week, this.is_even)
                    .then(data => {
                        this.setCurrentTimes();
                        this.bindElements();
                        if (resetOption === 'all-weeks') {
                            this.openingTimes[this.calendar.id][+ this.is_even][this.year]['0'] = data;
                        }
                    })
                        .catch(() => {});

                this.$event_bus.$emit('calendarReload');
            },

            specificDateText(weekday) {
                var moment_obj = moment(this.year + ' ' + this.week + ' ' + weekday, 'Y W E');
                var day = moment_obj.locale(moment_locale).format("Do");
                var month = moment_obj.locale(moment_locale).format("MMMM");
                return trans('calendar.opening_hours_specific_day', {day: day, month: month});
            },

            specificDateTextClosed(weekday) {
                var moment_obj = moment(this.year + ' ' + this.week + ' ' + weekday, 'Y W E');
                var day = moment_obj.locale(moment_locale).format("Do");
                var date = moment_obj.locale(moment_locale).format("DD");
                var month = moment_obj.locale(moment_locale).format("MMMM");
                return trans('calendar.closed_specific_day', {day: day, month: month, date: date});
            },
            closedEveryWeekday(weekday) {
                var weekday = moment().day(weekday).locale(moment_locale).format('dddd');
                return trans('calendar.closed_every_weekday', {weekday: weekday});
            },


            submitOpeningTimes() {
                this.loading = true;
                var times = this.setClosedValues(this.current_times);

                var url = '/app/calendar/';
                if (this.calendar) {
                    url += this.calendar.id + '/';
                }
                url += 'opening-times';

                return http.post(url, {dates: times, year: this.year, week: this.week, even: this.is_even})
                    .then(({ data }) => {
                        this.loading = false;

                        if (data.close_holidays) {
                            this.askCloseHolidays();
                        }

                        if (this.week == 0 || this.week == moment().week()) {
                            this.updateCalendarTimeFrame(data.calendar_min_time, data.calendar_max_time);
                        }

                        toastr.success(data.success);
                        this.$event_bus.$emit('calendarReload');

                        if (this.submission_handler) {
                            this.submission_handler();
                        }
                    }).catch(() => {});
            },

            weekdayHasPauses(weekday) {
                return this.current_pauses[weekday]
                    && this.current_pauses[weekday]
                        .filter((pause) => {
                            return pause.is_even === this.is_even;
                        }).length;
            },

            updateCalendarTimeFrame(minTime, maxTime) {
                var userOpeningTime = moment(this.user.calendarstarttime, 'HH:mm');
                var newOpeningTime = moment(minTime, 'HH:mm');
                var userClosingTime = moment(this.user.calendarendtime, 'HH:mm');
                var newClosingTime = moment(maxTime, 'HH:mm');
                var updateData = {};

                if (newOpeningTime.isBefore(userOpeningTime)) {
                    updateData.minTime = minTime;
                }

                if (newClosingTime.isAfter(userClosingTime)) {
                    updateData.maxTime = maxTime;
                }

                if (updateData.minTime || updateData.maxTime) {
                    this.$event_bus.$emit('updateCalendarTimeFrame', updateData);
                }
            },

            updateAvailableEndTimes (weekday) {
                const availableStartTimes = this.available_times;
                const thisOpeningTime = this.current_times[weekday].opening_time;
                const thisClosingTime = this.current_times[weekday].closing_time;
                const findIndex = availableStartTimes && availableStartTimes.findIndex(time => time === thisOpeningTime);

                // update the end times for a particular weekday when the start time is changed for that weekday
                if (findIndex === availableStartTimes.length - 1) {
                    this.available_end_times[weekday - 1] = availableStartTimes.slice(findIndex);
                } else {
                    this.available_end_times[weekday - 1]  = availableStartTimes.slice(findIndex + 1);
                }

                // check if the end time is the same or less than the start time -> if yes, choose the first value of the end times array for that weekday
                if (thisClosingTime <= thisOpeningTime) {
                    this.current_times[weekday].closing_time = this.available_end_times[weekday - 1][0];
                }
            },

            resetAvailableEndTimes () {
                this.available_end_times = Array(7).fill(this.available_times);
            },

            askCloseHolidays() {
                swal({
                    title:  trans('calendar.close_holidays_title'),
                    text: trans("calendar.close_holidays_description"),
                    html: true,
                    confirmButtonText: trans('global.close_all'),
                    showCancelButton: true,
                    cancelButtonText: trans('calendar.close_holidays_cancel_button'),
                    showLoaderOnConfirm: true,
                    closeOnConfirm: false,
                }, () => {
                    this.errors.clear();
                    this.loading = true;

                    http.post(`/app/calendar/${this.calendar.id}/close-holidays`, {year: this.year})
                        .then(({data}) => {
                            this.loading = false;
                            toastr.success(data.success);
                            swal.close();
                        })
                        .catch(({ error, errorBag }) => {
                            this.loading = false;
                            this.$setErrorBag(errorBag);
                        });
                });
            },
        },

        computed: {
            calendars() {
                return this.$store.getters['calendars/getCalendars']().filter((calendar) => {
                    return calendar.available_online_book && calendar.can_edit;
                });
            },

            week_numbers() {
                return range(1, 52);
            },

            years() {
                return range(moment().format('YYYY'), parseInt(moment().format('YYYY')) + 5);
            },

            available_break_times() {
                if (! this.new_pause || ! parseInt(this.new_pause.weekday)) {
                    return this.available_times;
                }

                return this.available_times.filter((time) => {
                    return time >= this.current_times[parseInt(this.new_pause.weekday)].opening_time &&
                        time <= this.current_times[parseInt(this.new_pause.weekday)].closing_time;
                });
            },

            available_break_end_times () {
                const availableStartTimes = this.available_break_times;

                if (! this.new_pause || ! parseInt(this.new_pause.weekday)) {
                    return availableStartTimes;
                }

                const findIndex = availableStartTimes && availableStartTimes.findIndex(time => time === this.new_pause.starttime);

                if (findIndex === availableStartTimes.length - 1) {
                    return availableStartTimes.slice(findIndex);
                } else {
                    return availableStartTimes.slice(findIndex + 1);
                }
            },

            no_week_selected() {
                return this.week == 0 || ! this.week;
            },
        },

        mixins: [TimePicker],

        watch: {
            calendar (val, oldVal) {
                if (!oldVal.id) {
                    this.week = '0';
                }

                this.loadOpeningTimes();
            },

            year (val, oldVal) {
                this.loadOpeningTimes();
            },

            week (val, oldVal) {
                this.is_even = val % 2 == 0;

                this.loadOpeningTimes();
            },

            is_even (val, oldVal) {
                this.loadOpeningTimes();
            },

            'new_pause.starttime' () {
                if (this.new_pause.endtime && this.new_pause.endtime <= this.new_pause.starttime) {
                    this.new_pause.endtime = this.available_break_end_times[0];
                }
            },
        },

        components: {
            DatePicker,
            Switchery,
        }
    }
</script>

<template>
    <div>
        <div class="preloader-overlay" v-if="loading">
            <div class="row">
                <div class="text-center col-sm-12">
                    <div class="preloader"></div>
                </div>
            </div>
        </div>

        <div class="opening-times-wrapper">

            <div class="p-20 opening-times-inner-wrapper">

                <div>
                    <form @submit.prevent="submitOpeningTimes" class="p-0 m-0 week-opening-time" id="opening-times-form" style="min-height: 400px;" >
                        <div class="flex justify-between m-b-20" v-if="show_submit_button">
                            <button type="submit" class="btn btn-custom"><i class="zmdi zmdi-check m-r-5"></i> <span>{{ trans('settings.save_settings') }}</span></button>
                            <button @click.prevent="showResetHoursForm" type="button" class="btn btn-custom btn-trans"><i class="zmdi zmdi-refresh m-r-5"></i><span>{{ trans('online_booking.reset') }}</span></button>
                        </div>

                        <div class="form-group" v-if="show_submit_button">
                            <div class="row">
                                <div class="col-xs-12 col-sm-5" v-if="calendars.length > 1">
                                    <label class="control-label">{{ trans('global.calendar') }} <i class="zmdi zmdi-circle m-l-5" :style='"color:" + calendar.color + ";"'></i></label>

                                    <select class="form-control form-control-opening-time-calendar" v-model="calendar">
                                        <option v-for="calendar in calendars" :value="calendar">{{ calendar.name }}</option>
                                    </select>
                                </div>

                                <div class="col-xs-12 col-sm-7">
                                    <label for="openingtimes-week-picker" class="control-label">{{ trans('calendar.showing_opening_times_specific_week') }}</label>
                                    <date-picker
                                        id="openingtimes-week-picker"
                                        name="week"
                                        :placeholder="trans('calendar.choose_week_cta')"
                                        :week_select="true"
                                        @week="changeWeek($event)"
                                        @year="changeYear($event)"
                                        :clearable="true"
                                    ></date-picker>
                                </div>
                            </div>
                        </div>

						<transition name="date" mode="out-in">
							<div class="row transition-row" v-if="week != 0">
								<div class="text-center col-sm-12 hidden-xs m-b-20">
									<ep-banner class="m-b-0" style="padding-top:5px; padding-bottom: 6px;">
										{{ trans('calendar.showing_opening_times_specific') }} <strong>{{ trans('calendar.week_number_title') }} {{ week }}, {{ year }}</strong>
									</ep-banner>
								</div>
							</div>
						</transition>

                        <div class="p-0 m-0">
                            <div class="mb-6 tabs-nav" v-if="calendar?.odd_even_opening_times">
                                <ul class="clearfix">
                                    <li :class="{ active: ! is_even }">
                                        <a @click.prevent="week > 0 && week % 2 === 0 ? null : is_even = false" href=""
                                            :style="{'cursor': week > 0 && week % 2 === 0 ? 'not-allowed' : 'pointer'}">
                                            {{ trans('online_booking.odd') }}
                                        </a>
                                    </li>
                                    <li :class="{ active: is_even }">
                                        <a @click.prevent="week == 0 || week % 2 === 0 ? is_even = true : null" href=""
                                            :style="{'cursor': week == 0 || week % 2 === 0 ? 'pointer' : 'not-allowed'}">
                                            {{ trans('online_booking.even') }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="form-group opening-time-group bg-box inverted-bg" v-for="(name, weekday) in weekdays" :key="weekday">
                                <div class="row" v-if="current_times[weekday]">
                                    <div class="col-xs-12 col-sm-2">
                                        <p class="opening-time-day-label">{{ trans('global.' + name) }}</p>
                                        <switchery :text="''" :identifier="'pause-' + weekday" v-model="current_times[weekday].open" name="'pause[' + weekday + ']'"></switchery>
                                    </div>

                                    <div class="col-xs-12 col-sm-10">
                                        <div class="row">
                                            <div v-show="current_times[weekday].open" class="col-xs-12 col-sm-6">
                                                <div class="opening-times-timespan">
                                                    <label class="control-label">
                                                        <small v-if="week == 0">{{ trans('calendar.showing_opening_times_every_day') }} {{ trans('global.' + name) }}</small>
                                                        <small v-else>{{ specificDateText(weekday) }}</small>
                                                    </label>

                                                    <hr class="m-0 m-b-10">

                                                    <div class="row">
                                                        <div class="col-xs-5">
                                                            <select v-model="current_times[weekday].opening_time" class="form-control input-sm" :name="'opening_time[' + weekday + ']'" @change="updateAvailableEndTimes(weekday)">
                                                                <option v-for="available_time in available_times" :key="available_time" v-bind:value="available_time">
                                                                    {{ available_time}}
                                                                </option>
                                                            </select>
                                                        </div>

                                                        <div class="text-center col-xs-2">
                                                            <p class="m-0 m-t-5">{{ trans('global.to') }}</p>
                                                        </div>

                                                        <div class="col-xs-5">
                                                            <select v-model="current_times[weekday].closing_time" class="form-control input-sm" :name="'opening_time[' + weekday + ']'">
                                                                <option v-for="available_time in available_end_times[weekday - 1]" :key="available_time" v-bind:value="available_time">
                                                                    {{ available_time}}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-show="current_times[weekday].open" class="col-xs-12 col-sm-6 opening_times_pauses">
                                                <div class="opening-times-pauses-inner">
                                                    <label class="control-label"><small>{{ trans('online_booking.breaks') }}</small> </label> <a href="" @click.prevent="showPauseForm(weekday)" class="pull-right"><small><i class="fa-regular fa-plus m-r-5"></i>{{ trans('online_booking.add_pause_label') }}</small></a>

                                                    <hr class="m-0 m-b-10">

                                                    <div v-if="weekdayHasPauses(weekday)">
                                                        <span class="label label-default m-r-5" v-for="pause in orderedWeekdayPauses(weekday)">{{ getTimeFromDateString(pause.starttime) }} - {{ getTimeFromDateString(pause.endtime) }} <a href="#" @click.prevent="removePause(pause)"><i class="zmdi zmdi-close m-l-5"></i></a></span>
                                                    </div>

                                                    <em v-else><small>{{ trans('online_booking.no_breaks_added') }}</small></em>
                                                </div>
                                            </div>

                                            <div v-show="!current_times[weekday].open" class="text-center opening-times-closed-wrap col-xs-12 col-sm-12">
                                                <div class="row" v-if="week != 0">
                                                    <h3 style="margin-bottom:20px;margin-top:21px;">{{ specificDateTextClosed(weekday) }}</h3>
                                                </div>
                                                <div class="row" v-else>
                                                    <h3 style="margin-bottom:20px;margin-top:21px;">{{ closedEveryWeekday(weekday) }}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div id="pause-modal" class="modal fade" tabindex="-2" role="dialog" aria-hidden="true" style="display: none;">
            <div class="modal-dialog">
                <div class="m-0 panel panel-color panel-inverse">
                    <div class="panel-heading">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h3 class="truncate panel-title"><i class="zmdi zmdi-alarm-snooze m-r-10"></i>{{ trans('online_booking.add_pause_label') }}</h3>
                    </div>
                </div>

                <div class="modal-content">
                    <div class="p-0 modal-body">
                        <form @submit.prevent="createPause">

                            <div class="form-group">

                            <div class="row">
                                <div class="col-xs-6 col-sm-4">
                                    <label class="control-label">{{ trans('online_booking.pause_start') }}</label>
                                    <select v-model="new_pause.starttime" class="form-control">
                                        <option v-for="time in available_break_times" :key="time">{{ time }}</option>
                                    </select>
                                </div>
                                <div class="col-xs-6 col-sm-4">
                                    <label class="control-label">{{ trans('online_booking.pause_end') }}</label>
                                    <select v-model="new_pause.endtime" class="form-control">
                                        <option v-for="time in available_break_end_times" :key="time">{{ time }}</option>
                                    </select>
                                </div>
                            </div>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="submit" class="btn btn-custom " @click.prevent="createPause">{{ trans('clients.submit') }}</button>
                    </div>
                </div>
            </div>
        </div>

        <div id="opening-hours-reset-modal" class="modal fade" tabindex="-2" role="dialog" aria-hidden="true" style="display: none;">
            <div class="modal-dialog">
                <div class="m-0 panel panel-color panel-inverse">
                    <div class="panel-heading">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h3 class="truncate panel-title">
                            <i class="zmdi zmdi-alarm-snooze m-r-10"></i>{{ trans('online_booking.reset_hours_label') }}<br>
                            <span class="text-sm">({{ trans('online_booking.reset_hours_label_information') }})</span>
                        </h3>
                    </div>
                </div>

                <div class="modal-content">
                    <div class="p-0 modal-body">
                        <form @submit.prevent="resetHours">

                            <div class="form-group">

                                <div class="row">
                                    <div class="col-xs-12">
                                        <div class="m-0 form-group no-help-text">
                                            <div class="radio m-t-0">
                                                <input type="radio" name="reset_this_week" id="reset_this_week" v-model="reset_hour_option" value="this-week" :disabled="no_week_selected">
                                                <label for="reset_this_week">{{ trans('online_booking.reset_options.this_week') }}</label>
                                            </div>
                                        </div>

                                        <div class="m-0 form-group no-help-text">
                                            <div class="radio m-t-0">
                                                <input type="radio" name="reset_this_and_future_weeks" id="reset_this_and_future_weeks" v-model="reset_hour_option" value="this-and-future-weeks" :disabled="no_week_selected">
                                                <label for="reset_this_and_future_weeks">{{ trans('online_booking.reset_options.this_and_future_weeks') }}</label>
                                            </div>
                                        </div>

                                        <div class="m-0 form-group no-help-text">
                                            <div class="radio m-t-0">
                                                <input type="radio" name="reset_all_weeks" id="reset_all_weeks" v-model="reset_hour_option" value="all-weeks">
                                                <label for="reset_all_weeks">{{ trans('online_booking.reset_options.all_weeks_including_past') }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="submit" class="btn btn-custom " @click.prevent="resetHours" :disabled="submitting_reset_hours">
                            <i class="zmdi zmdi-spinner m-r-10 fa-spin" v-show="submitting_reset_hours"></i>
                            {{ trans('online_booking.reset') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
